import React from "react";
import { connect } from "react-redux";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import DocumentDialogContent from "./ProveedorFirma";
import { Modal, Button } from "react-bootstrap";
import { getProveedoresFirmas } from "./ProveedorFirmaService";
import ProveedorFirmaDatos from "./ProveedorFirmaDatos";
import  Navbar  from '../home/Navbar';
import visibility from '../../styles/icons/visibility.svg';
import editIcon from '../../styles/icons/edit.svg'
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";


class ProveedoresFirma extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dialogTitle: "Registrar nuevo proveedor de firma",
            dialogType: "add",
            submitText: "Guardar",
            disabledInput: false,
            selectedProveedor: {
                id: "",
                clientSecret: "",
                clientId: "",
                descripcion: "",
                schema: "",
                host: "",
                port: "",
                activo: true,
            },
            dialogIsOpen: false,
            dialogIsOpenVerDatos: false,
            mensajeFlash: "",
            mostrarMensajeFlash: false,
            loading:true,
            pageSize:10,
            search:""
        }
        this.tableRef = React.createRef();
    }



    handleDialog = (value, mensaje = "") => {
        if (value === false) {
          this.fetchProveedores(0, this.state.pageSize, "");
            if (mensaje != "") {
                this.setState({
                    mostrarMensajeFlash: true,
                    mensajeFlash: mensaje
                });
            }
        }
        this.setState({ dialogIsOpen: value });
    };

    handleCloseMensajeFlash = () => {
        this.setState({
            mostrarMensajeFlash: false,
        });
    };

    handleDialogVerDatos = (value) => {
        if (value === false) {
          this.fetchProveedores(0, this.state.pageSize, "");
        }
        this.setState({
            dialogIsOpenVerDatos: value,
        });
    };

    handleNewProveedor = () => {
        this.setState(
          {
            dialogTitle: "Nuevo proveedor de firma",
            selectedProveedor: {
                id: "",
                clientSecret: "",
                clientId: "",
                descripcion: "",
                schema: "",
                host: "",
                port: "",
                activo: true,
            },
            dialogType: "add",
            submitText: "Guardar",
            disabledInput: false,
            loading: true,
            search: "",
            pageSize: 10
          },
          () => {
            this.handleDialog(true);
          }
        );
      };
    handlePageChange(newPage) {
      if (newPage >= 0 && newPage < this.state.totalPages) {
        this.setState({ page: newPage }, () => {
          this.fetchProveedores(newPage, this.state.pageSize, "");
        });
      }
    }
    componentDidMount() {
      this.fetchProveedores(0, this.state.pageSize, "");
    }
  
    handlePageChange = (newPage) => {
      if (newPage >= 0 && newPage < this.state.totalPages) {
        this.setState({ page: newPage }, () => {
          this.fetchProveedores(this.state.page, this.state.pageSize, "");
        });
      }
    };
  
    handlePageSizeChange = (event) => {
      const newPageSize = parseInt(event.target.value, 10);
      this.setState({ pageSize: newPageSize, page: 0 }, () => {
        this.fetchProveedores(this.state.page, this.state.pageSize, "");
      });
    };
  
    renderPageNumbers() {
      const { page, totalPages } = this.state;
      const maxVisiblePages = 5; // Máximo de páginas visibles
  
      let pages = [];
  
      if (totalPages <= maxVisiblePages) {
        // Mostrar todas las páginas si son pocas
        for (let i = 0; i < totalPages; i++) {
          pages.push(
            <li
              key={i}
              className={`page-item ${page === i ? "active" : ""}`}
              onClick={() => this.handlePageChange(i)}
            >
              <a className="page-link" type="Button">{i + 1}</a>
            </li>
          );
        }
      } else {
        // Mostrar primeras páginas, últimas y cercanas a la actual
        const startPage = Math.max(0, page - 2);
        const endPage = Math.min(totalPages - 1, page + 2);
  
        // Agregar primera página
        if (startPage > 0) {
          pages.push(
            <li
              key={0}
              className={`page-item ${page === 0 ? "active" : ""}`}
              onClick={() => this.handlePageChange(0)}
            >
              <a className="page-link" type="Button">1</a>
            </li>
          );
          if (startPage > 1) {
            pages.push(
              <li key="start-ellipsis" className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            );
          }
        }
  
        // Agregar páginas visibles
        for (let i = startPage; i <= endPage; i++) {
          pages.push(
            <li
              key={i}
              className={`page-item ${page === i ? "active" : ""}`}
              onClick={() => this.handlePageChange(i)}
            >
              <a className="page-link" type="Button">{i + 1}</a>
            </li>
          );
        }
  
        // Agregar última página
        if (endPage < totalPages - 1) {
          if (endPage < totalPages - 2) {
            pages.push(
              <li key="end-ellipsis" className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            );
          }
          pages.push(
            <li
              key={totalPages - 1}
              className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
              onClick={() => this.handlePageChange(totalPages - 1)}
            >
              <a className="page-link" type="Button">{totalPages}</a>
            </li>
          );
        }
      }
  
      return pages;
    }
  
    fetchProveedores(page, pageSize, search) {
      this.setState({ loading: true });
      this.props.getProveedoresFirmas(page, pageSize, search).then(() => {
        this.setState({
          proveedores: this.props.proveedorData.proveedores,
          page: this.props.proveedorData.page,
          totalCount: this.props.proveedorData.totalCount,
          totalPages: Math.ceil(
            this.props.proveedorData.totalCount / pageSize
          ),
          loading: false,
        });
      });
    }
  
    handleSearchChange = (e) => {
      const searchValue = e.target.value;
      this.setState({ search: searchValue }, () => {
        this.fetchProveedores(0, this.state.pageSize, this.state.search);
      });
    };
    render() {
        return (
            <div>
                <div className="dashboardContent">
                    <div className="container-fluid">
                        <MensajeFlash
                            mensaje={this.state.mensajeFlash}
                            severity={"success"}
                            open={this.state.mostrarMensajeFlash}
                            handleClose={this.handleCloseMensajeFlash} />
                        <Modal
                            size="lg"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            show={this.state.dialogIsOpen}
                            onHide={this.handleDialog}
                            backdrop="static"
                            keyboard="false">
                            <DocumentDialogContent
                                proveedor={this.state.selectedProveedor}
                                handleClose={this.handleDialog}
                                type={this.state.dialogType}
                                submitText={this.state.submitText}
                                disabledInput={this.state.disabledInput}
                                dialogTitle={this.state.dialogTitle}
                            />
                        </Modal>
                        <Modal
                            size="lg"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            show={this.state.dialogIsOpenVerDatos}
                            onHide={this.handleDialogVerDatos}
                            backdrop="static"
                            keyboard="false">
                            <ProveedorFirmaDatos
                                proveedor={this.state.selectedProveedor}
                                handleClose={this.handleDialogVerDatos}
                                type={this.state.dialogType}
                                submitText={this.state.submitText}
                                disabledInput={this.state.disabledInput}
                                dialogTitle={this.state.dialogTitle}
                            />
                        </Modal>
                        <div className="sectionHeader">
                            <h1 className="pageTitle"> Proveedores de firma digital </h1>
                            <div className="actions">
                                <Button
                                    color="primary"
                                    onClick={this.handleNewProveedor}
                                >
                                    Nuevo proveedor de firmas
                                </Button>
                            </div>
                        </div>
                        <Navbar
                            menuActual={window.location.hash}
                            seccionActual={'administracion'}
                        />
          <div className="contentBuscador card">
              <form className="searchForm">
                <div className="input-group input-group-lg">
                  <span className="input-group-text border-0" id="basic-addon2">
                    <img src={search} />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Buscar.."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </form>
            </div>
            <div className="contentPage card" style={{ padding: "0px" }}>
            {this.state.loading ? (
                // Muestra el spinner mientras loading sea true
                <div className="d-flex justify-content-center p-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : (<div>
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Cliente ID</th>
                      <th scope="col">Descripcion</th>
                      <th scope="col">Estado</th>
                      <th scope="col">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.proveedorData.proveedores.map((proveedor, index) => (
                      <tr key={index}>
                        <th scope="row">{proveedor.clientId}</th>
                        <td>{proveedor.descripcion}</td>
                        <td>{proveedor.activo}</td>
                        <td>
                          <div className="table-actions">
                          <a class="btn btn-secondary btn-md btn-floating" onClick={() => {
                                            this.setState({
                                                dialogTitle: "Editar datos de proveedor",
                                                selectedProveedor: proveedor,
                                                dialogType: "edit",
                                                submitText: "Editar",
                                                disabledInput: false
                                            }, () => {
                                                this.handleDialog(true);
                                            });
                                        }}>
                          <img src={editIcon} />
                          </a>
                          <a class="btn btn-secondary btn-md btn-floating" onClick={() => {
                                            this.setState({
                                                dialogTitle: "Detalles del proveedor",
                                                selectedProveedor: proveedor,
                                                dialogType: "edit",
                                                submitText: "Editar",
                                                disabledInput: false
                                            }, () => {
                                                this.handleDialogVerDatos(true);
                                            });
                                        }}>
                          <img src={visibility} />
                          </a>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div id="paginador">
                    <label>
                      Mostrar
                      <select
                        className="form-control custom-select"
                        id="maxRows"
                        name="state"
                        value={this.state.pageSize}
                        onChange={this.handlePageSizeChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                      resultados.
                    </label>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          this.state.page === 0 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page - 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_left</span>
                        </a>
                      </li>
                      {this.renderPageNumbers()}
                      <li
                        className={`page-item ${
                          this.state.page === this.state.totalPages - 1
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page + 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_right</span>
                        </a>
                      </li>
                    </ul>
                  </div>
              </div>)}
            </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapDispatchToProps = (dispatch) => ({
    getProveedoresFirmas: (page, size, search) => dispatch(getProveedoresFirmas(page, size, search)),
});

const mapStateToProps = (state) => ({
    proveedorData: state.proveedoresData
});

export default connect(mapStateToProps, mapDispatchToProps)(ProveedoresFirma);